module.exports = "./public/form-integration-assets/pointer-icon.svg?5eb0a825ff8e9df4cc9b8393416540f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pointer-icon.svg
// module id = 45
// module chunks = 0